const STATUSES = {
    NOT_BOOKED_STATUS: 'NOT_BOOKED',
    BOOKED_STATUS: 'BOOKED',
    REFUSED_STATUS: 'REFUSED'
};

export {
    STATUSES
};
